import React, { useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { FORMAT_DATE } from "utils/constantValues";
import LabelComponent from "pages/profile/common/label";
import { ReactComponent as EditIcon } from "images/profile/edit-icon.svg";

function LegalDetailsInformation({
  onEditClick = () => {},
  isShowEditIcon = false,
}) {
  const [t] = useTranslation();
  const [isEditShowEditOnHover, setShowEditOnHover] = useState(false);
  const userDetails = useSelector((state) => state.userDetails || {});
  const personal = userDetails?.extraInformation?.personalDetails || {};

  const formatDate = (value) =>
    value ? moment(value).format(FORMAT_DATE) : "-";
  const user = useSelector((state) => state.user || {});

  const isLoggedInByMagicLink = user?.isAdmin ?? false;

  return (
    <div
      id="legalDetailsSection"
      className={`flex p-[24px] flex-col gap-[12px] self-stretch cursor-pointer ${
        isEditShowEditOnHover ? "bg-[#F3F5F7]" : ""
      }`}
      onMouseEnter={() => setShowEditOnHover(true)}
      onMouseLeave={() => setShowEditOnHover(false)}
    >
      <div className="flex flex-col items-start gap-3 self-stretch">
        <div className="flex justify-between items-center self-stretch">
          <span className="text-[#1D1B22] text-center font-semibold text-[24px] leading-[36px] font-['General_Sans']">
            {t("legalDetailsTitle")}
          </span>
          {isLoggedInByMagicLink
            ? false
            : isShowEditIcon && (
                <EditIcon
                  className={`cursor-pointer ${
                    isEditShowEditOnHover ? "visible" : "invisible"
                  }`}
                  onClick={onEditClick}
                />
              )}
        </div>
      </div>

      <div className="flex items-start content-start gap-x-6 gap-y-[30px] self-stretch flex-wrap">
        <div className="flex w-[330px] flex-col items-start gap-[2px]">
          <LabelComponent
            title={t("gender")}
            subTitle={`${personal?.gender ?? "-"}`}
          />
        </div>
        <div className="flex w-[330px] flex-col items-start gap-[2px]">
          <LabelComponent
            title={t("dateOfBirth")}
            subTitle={`${formatDate(personal?.dateOfBirth)}`}
          />
        </div>
        <div className="flex w-[330px] flex-col items-start gap-[2px]">
          <LabelComponent
            title={t("martialStatus")}
            subTitle={`${personal?.martialStatus ?? "-"}`}
          />
        </div>
        <div className="flex w-[330px] flex-col items-start gap-[2px]">
          <LabelComponent
            title={t("countryOfBirth")}
            subTitle={`${personal?.countryOfBirth ?? "-"}`}
          />
        </div>
        <div className="flex w-[330px] flex-col items-start gap-[2px]">
          <LabelComponent
            title={t("socialSecurityNumber")}
            subTitle={`${personal?.socialSecurityNo ?? "-"}`}
          />
        </div>
        <div className="flex w-[330px] flex-col items-start gap-[2px]">
          <LabelComponent
            title={t("nationalCardNo")}
            subTitle={`${personal?.nationalCardNo ?? "-"}`}
          />
        </div>
        <div className="flex w-[330px] flex-col items-start gap-[2px]">
          <LabelComponent
            title={t("passportNo")}
            subTitle={`${personal?.passportNo ?? "-"}`}
          />
        </div>
        <div className="flex w-[330px] flex-col items-start gap-[2px]">
          <LabelComponent
            title={t("expiryDate")}
            subTitle={`${formatDate(personal?.expiryDate)}`}
          />
        </div>
        <div className="flex w-[330px] flex-col items-start gap-[2px]">
          <LabelComponent
            title={t("countryOfIssue")}
            subTitle={`${personal?.countryOfIssue ?? "-"}`}
          />
        </div>
        <div className="flex w-[330px] flex-col items-start gap-[2px]">
          <LabelComponent
            title={t("placeOfIssue")}
            subTitle={`${personal?.placeOfIssue ?? "-"}`}
          />
        </div>
      </div>
    </div>
  );
}

LegalDetailsInformation.propTypes = {
  onEditClick: PropTypes.func,
  isShowEditIcon: PropTypes.bool,
};

export default LegalDetailsInformation;
